module.exports = __webpack_public_path__ + "img/EUR.07218bbb.png";